/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { VodItem, VodItemList } from 'client-code/vod-browse';

import type { TivoPayloadAction } from '../../core/tivo/tivo-redux-wrapper';
import {
    VOD_BROWSE_MS_CLEAR_DATA,
    VOD_BROWSE_MS_UPDATE_HORIZONTAL_ITEMS,
    VOD_BROWSE_MS_UPDATE_HORIZONTAL_POSITIONS,
    VOD_BROWSE_MS_UPDATE_SHOULD_HIDE_ADULT_STATE,
    VOD_BROWSE_MS_UPDATE_VERTICAL_ITEMS,
} from './vodbrowsemainscreen.types';

export type TVodBrowseItems = {
    horizontalItems: Array<VodItemList>;
    horizontalPositions: Array<number>;
    verticalItems: Array<VodItem>;
    shouldHideAdultState: boolean;
};

export const vodBrowseMainScreenClearDataAction = (): TivoPayloadAction<TVodBrowseItems> => ({
    type: VOD_BROWSE_MS_CLEAR_DATA,
    payload: {
        horizontalItems: [],
        horizontalPositions: [],
        verticalItems: [],
        shouldHideAdultState: true,
    },
});

export const vodBrowseMainScreenUpdateHorizontalPositionsAction = (
    horizontalPositions: Array<number>,
): TivoPayloadAction<{ horizontalPositions: Array<number> }> => ({
    type: VOD_BROWSE_MS_UPDATE_HORIZONTAL_POSITIONS,
    payload: { horizontalPositions },
});

export const vodBrowseMainScreenUpdateVerticalItemsAction = (
    verticalItems: Array<VodItem>,
): TivoPayloadAction<{ verticalItems: Array<VodItem> }> => ({
    type: VOD_BROWSE_MS_UPDATE_VERTICAL_ITEMS,
    payload: {
        verticalItems,
    },
});

export const vodBrowseMainScreenUpdateHorizontalItemsAction = (
    horizontalItems: Array<VodItemList>,
): TivoPayloadAction<{ horizontalItems: Array<VodItemList> }> => ({
    type: VOD_BROWSE_MS_UPDATE_HORIZONTAL_ITEMS,
    payload: {
        horizontalItems,
    },
});

export const vodBrowseMainScreenUpdateShouldHideAdultStateAction = (
    shouldHideAdultState: boolean,
): TivoPayloadAction<{ shouldHideAdultState: boolean }> => ({
    type: VOD_BROWSE_MS_UPDATE_SHOULD_HIDE_ADULT_STATE,
    payload: {
        shouldHideAdultState,
    },
});
